import projection from '../generated/pwm5m3f1.json';
import { AcceptanceManifest } from '../types';

export const pwm5m3f1AcceptanceManifest = projection as AcceptanceManifest;
